import { NgModule } from '@angular/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatTreeModule } from '@angular/material/tree';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatBadgeModule } from "@angular/material/badge";
import { MatDatepickerModule } from '@angular/material/datepicker';

@NgModule({
    exports: [
        MatDialogModule,
        MatSnackBarModule,
        MatCardModule,
        MatButtonModule,
        MatSidenavModule,
        MatListModule,
        MatTreeModule,
        MatIconModule,
        MatInputModule,
        MatToolbarModule,
        MatProgressBarModule,
        MatInputModule,
        MatMenuModule,
        MatTableModule,
        MatSortModule,
        MatSelectModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
        MatExpansionModule,
        MatBadgeModule,
        MatDatepickerModule
    ]
})
export class MaterialModule { }
